import React from 'react';
import { Link } from 'react-router';
import PropTypes from 'prop-types';

const nodeType = PropTypes.shape({
    id:         PropTypes.number.isRequired,
    name:       PropTypes.string.isRequired,
    courses:    PropTypes.number,
    modules:    PropTypes.number,
    children:   PropTypes.arrayOf(nodeType),
});

export const CategoryElement = ({node, level = 0, prefix = 'category-tree'}) => (
    <li className={`cent-list-plain ${prefix} level-${level} ${prefix}-node`}>
        <Link to={`/dashboard/library/${node.id}`}>{node.name}</Link> ({node.courses || 0} / {node.modules || 0})
        {node.children && node.children.length > 0 && (<CategoryLevel nodes={node.children} level={level} prefix={prefix} />)}
    </li>
);

CategoryElement.propTypes = {
    node: nodeType.isRequired,
    level: PropTypes.number.isRequired,
    prefix: PropTypes.string.isRequired
};

export const CategoryLevel = ({nodes, level = 0, prefix = 'category-tree', children}) => {
    if (!nodes || (nodes.length === 0)) { return null; }
    return (
        <ul className={`cent-list-plain ${prefix}  level-${level}`}>
            {nodes.map(node => <CategoryElement key={node.id} node={node} level={level + 1} prefix={prefix} />)}
            {children}
        </ul>
    );
};

CategoryLevel.propTypes = {
    nodes: PropTypes.arrayOf(nodeType).isRequired,
    level: PropTypes.number,
    prefix: PropTypes.string
};

CategoryLevel.defaultProps = {
    level: 0,
    prefix: 'category-tree'
};
